import TabCarCarousel from './tab-car-carousel';
export default TabCarCarousel;
export { TabCarCarousel };
